import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useBilling } from "@/context/BillingContext";
import { Button } from "@/components/ui/button";
import { Compass, LogOut, Sparkles } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const { isPaid, tier } = useBilling();
  const nav = useNavigate();
  const loc = useLocation();

  async function handleLogout() {
    await logout();
    nav("/login");
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 glass border-b border-border">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <div className="w-9 h-9 rounded-xl bg-primary text-primary-foreground grid place-items-center">
              <Compass className="w-5 h-5" />
            </div>
            <div className="font-display text-lg font-semibold tracking-tight">TravelVault</div>
          </Link>
          <nav className="flex items-center gap-2">
            {user && (
              <>
                <Link
                  to="/"
                  className={`px-3 py-1.5 rounded-full text-sm transition-colors ${loc.pathname === "/" ? "bg-primary text-primary-foreground" : "text-stone-700 hover:bg-muted"}`}
                  data-testid="nav-trips"
                >
                  Trips
                </Link>
                <Link
                  to="/pricing"
                  className={`px-3 py-1.5 rounded-full text-sm transition-colors flex items-center gap-1 ${loc.pathname === "/pricing" ? "bg-primary text-primary-foreground" : "text-stone-700 hover:bg-muted"}`}
                  data-testid="nav-billing"
                >
                  {isPaid ? <Sparkles className="w-3.5 h-3.5" /> : null}
                  {isPaid ? (tier === "family" ? "Family" : "Pro") : "Upgrade"}
                </Link>
                <div className="hidden md:block text-sm text-stone-500 px-3" data-testid="user-email">{user.email}</div>
                <Button variant="ghost" size="sm" onClick={handleLogout} className="rounded-full" data-testid="logout-btn">
                  <LogOut className="w-4 h-4 mr-2" /> Logout
                </Button>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
      <footer className="max-w-7xl mx-auto px-6 py-10 text-xs text-stone-500">
        Built for wanderers. All your travel docs in one place.
      </footer>
    </div>
  );
}
